import { Link } from "react-router-dom";
import styled from "styled-components";

export const FooterWrapper = styled.footer`
  width: 100%;
  padding: 10px 0;
  border-top: 1px solid ${(props) => props.theme.borderColor};
`;

export const FooterMain = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  @media (max-width: 991.98px) {
    flex-direction: column;
    height: auto;
  }
`;

export const FooterLogo = styled(Link)`
  @media (max-width: 991.98px) {
    margin-bottom: 10px;
    margin-top: 10px;
  }
  & svg {
    & path {
      fill: ${(props) => props.theme.textColor};
    }
  }
`;

export const FooterNavBar = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 991.98px) {
    margin-bottom: 10px;
    margin-top: 10px;
  }
  @media (max-width: 768.98px) {
    flex-direction: column;
    margin: 0;
  }
  & a {
    margin: 0 10px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    @media (max-width: 768.98px) {
      margin: 10px;
    }
  }
`;

export const LangSwitchWrapperFooter = styled.div`
  position: relative;
  margin-left: 10px;
  width: 120px;
  height: 40px;
  & svg {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 8px;
    z-index: 2;
    transition: 0.2s;
    transform: ${(props) => (props.showLangSwitch ? "rotate(90deg)" : "rotate(0deg)")};
    & path {
      fill: ${(props) => props.theme.textColor};
    }
  }
  @media (max-width: 768px) {
    margin: 10px 0 30px;
  }
`;

export const LangSwitchFooter = styled.div`
  width: 120px;
  height: ${(props) => (props.showLangSwitch ? "90px" : "40px")};
  color: ${(props) =>
    props.whiteText & (props.theme.current == "light")
      ? (props) => props.theme.textColor
      : props.whiteText
      ? "#fff"
      : (props) => props.theme.textColor};
  background: ${(props) => props.theme.bgColor};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: ${(props) => (props.showLangSwitch ? "20px" : "20px")};
  cursor: pointer;
  display: flex;
  align-items: right;
  justify-content: center;
  transition: 0.2s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 1;
  padding-left: 10px;
  & span {
    padding: 2px 0;
    &.hidden {
      display: ${(props) => (props.showLangSwitch ? "block" : "none")};
    }
  }
`;

export const FooterCopyright = styled.div`
  width: 100%;
  text-align: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 126.2%;
  color: ${(props) => props.theme.textColor};
`;
